module.exports = __webpack_public_path__ + "img/arrow_left.f37236b7.svg";